import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchUserInfo = useCallback(async () => {
    try {
      const response = await fetch('/api/user/info', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      if (response.status === 401) {
        navigate('/user/login');
        return;
      }

      if (!response.ok) {
        throw new Error(await response.json());
      }

      const data = await response.json();
      setUserInfo(data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    fetchUserInfo();
  }, [fetchUserInfo, navigate]);

  return { userInfo, loading };
};
